import React from 'react';
import PropTypes from 'prop-types';
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CircularProgress from '@material-ui/core/CircularProgress';
import Postpaid from "components/Selfcare/Overview/Postpaid";
import PostpaidFreeData from "components/Selfcare/Overview/PostpaidFreeData";
import Prepaid from "components/Selfcare/Overview/Prepaid";
import Data from "components/Selfcare/Overview/Data";


class SubscriptionUsage extends React.Component {

    render() {
        const { subscription, loadingSubscription, classes, navigateTo } = this.props;
        
        return (
            <GridContainer spacing={0}>
                <GridItem xs={12} style={{ marginBottom: '8px' }}>
                    {!loadingSubscription && subscription && subscription.IsPrepaid && !subscription.IsData && <Prepaid color="rose" subscription={subscription} classes={classes} navigateTo={navigateTo} />}
                    {!loadingSubscription && subscription && subscription.IsPostpaid && !subscription.IsData && subscription.DataPot && subscription.DataPot.FreeData && <PostpaidFreeData color="rose" subscription={subscription} classes={classes} navigateTo={navigateTo}/>}
                    {!loadingSubscription && subscription && subscription.IsPostpaid && !subscription.IsData && subscription.DataPot && !subscription.DataPot.FreeData && <Postpaid color="rose" subscription={subscription} classes={classes} navigateTo={navigateTo} />}
                    {!loadingSubscription && subscription && subscription.IsPostpaid && subscription.IsData && subscription.DataPot && <Data color="rose" subscription={subscription} classes={classes} navigateTo={navigateTo} />}
                    {loadingSubscription && <CircularProgress size={48} className={classes.buttonProgress} />}
                </GridItem >
            </GridContainer> 
        );
    }
}

SubscriptionUsage.propTypes = {
    loadingSubscription: PropTypes.bool.isRequired,
    navigateTo: PropTypes.func.isRequired,
    subscription: PropTypes.object.isRequired,
};

export default SubscriptionUsage;
